import type { TConfigState } from "@/types/state-types"
import { mapToTitleValueFormat } from '@/utils/helpers/app-helpers'

export default {
  cargoVolumeUnits(state: TConfigState) {
    return mapToTitleValueFormat(state.unitsConfig?.CargoVolume?.units)
  },
  engineDisplacementUnits(state: TConfigState) {
    return mapToTitleValueFormat(state.unitsConfig?.EngineDisplacement?.units)
  },
  enginePowerUnits(state: TConfigState) {
    return mapToTitleValueFormat(state.unitsConfig?.EnginePower?.units)
  },
  engineTorqueUnits(state: TConfigState) {
    return mapToTitleValueFormat(state.unitsConfig?.EngineTorque?.units)
  },
  fuelConsumptionUnits(state: TConfigState) {
    return mapToTitleValueFormat(state.unitsConfig?.FuelConsumption?.units)
  },
  fuelFillingUnits(state: TConfigState) {
    return mapToTitleValueFormat(state.unitsConfig?.FuelFilling?.units)
  },
  fuelTankCapacityUnits(state: TConfigState) {
    return mapToTitleValueFormat(state.unitsConfig?.FuelTankCapacity?.units)
  },
  groundClearanceUnits(state: TConfigState) {
    return mapToTitleValueFormat(state.unitsConfig?.GroundClearance?.units)
  },
  odometerReadingUnits(state: TConfigState) {
    return mapToTitleValueFormat(state.unitsConfig?.OdometerReading?.units)
  },
  trackWidthUnits(state: TConfigState) {
    return mapToTitleValueFormat(state.unitsConfig?.TrackWidth?.units)
  },
  tyrePressureUnits(state: TConfigState) {
    return mapToTitleValueFormat(state.unitsConfig?.TyrePressure?.units)
  },
  vehicleDimensionsUnits(state: TConfigState) {
    return mapToTitleValueFormat(state.unitsConfig?.VehicleDimensions?.units)
  },
  vehicleSpeedUnits(state: TConfigState) {
    return mapToTitleValueFormat(state.unitsConfig?.VehicleSpeed?.units)
  },
  vehicleWeightUnits(state: TConfigState) {
    return mapToTitleValueFormat(state.unitsConfig?.VehicleWeight?.units)
  },
  wheelDiameterUnits(state: TConfigState) {
    return mapToTitleValueFormat(state.unitsConfig?.WheelDiameter?.units)
  },
}